import React from 'react';
import { Loader2 } from 'lucide-react';
import { TablePaginationFooter } from '../../shared/table/TablePaginationFooter.tsx';
import { RcmMatrixTableHeader } from './RcmMatrixTableHeader.jsx';


/**
 * Scrollable RCM grid shell: sticky header, body slot, server pagination footer.
 */
export function RcmMatrixTable({
  showOverlay,
  onSortClick,
  renderSortIcon,
  columnVisibility,
  columnOrder,
  columnVisibilityMenu,
  children,
  showPagination,
  paginationFrom,
  paginationTo,
  totalItems,
  listPage,
  totalPages,
  pageSize,
  onPaginationChange,
}) {
  const safePage = Math.min(Math.max(1, listPage), Math.max(1, totalPages));


  return (
    <div className="flex-1 min-h-0 min-w-0 w-full flex flex-col">
      <div
        className="bg-white rounded-lg border border-gray-200 shadow-sm h-full w-full min-w-0 flex flex-col overflow-hidden"
      >
        {columnVisibilityMenu ? (
          <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-end shrink-0">
            {columnVisibilityMenu}
          </div>
        ) : null}
        <div className="relative flex-1 min-h-0 overflow-x-auto overflow-y-auto">
          {showOverlay ? (
            <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/60" aria-busy="true">
              <Loader2 className="h-8 w-8 text-teal-600 animate-spin" />
            </div>
          ) : null}
          <table className="min-w-[1800px] w-full border-separate border-spacing-0">
            <RcmMatrixTableHeader
              onSortClick={onSortClick}
              renderSortIcon={renderSortIcon}
              columnVisibility={columnVisibility}
              columnOrder={columnOrder}
            />
            <tbody>{children}</tbody>
          </table>
        </div>
        {showPagination ? (
          <TablePaginationFooter
            className="shrink-0"
            from={paginationFrom}
            to={paginationTo}
            total={totalItems}
            itemLabel="risk-control mappings"
            pageIndex={safePage - 1}
            pageCount={Math.max(1, totalPages)}
            canPreviousPage={safePage > 1}
            canNextPage={safePage < totalPages}
            onPreviousPage={() => onPaginationChange((p) => ({ ...p, pageIndex: p.pageIndex - 1 }))}
            onNextPage={() => onPaginationChange((p) => ({ ...p, pageIndex: p.pageIndex + 1 }))}
            showPageSizeSelector
            pageSize={pageSize}
            onPageSizeChange={(nextSize) => {
              onPaginationChange({ pageIndex: 0, pageSize: nextSize });
            }}
          />
        ) : null}
      </div>
    </div>
  );
}
